import { panelSnapshotPosts } from './PanelSnapshotPosts';

const singlePostSnapshot = {
    id: 'cGFuZWw6NWQ4ZDEwODRjYmU5OTMwZTE3OGQ3Mzdi',
    partnerId: 349,
    clientId: 7101,
    name: 'Single Post',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4ZDEwODRjYmU5OTMwZTE3OGQ3Mzdh',
        name: 'Scene 22',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'single post',
                type: 'postsSinglePost',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 6,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'rotate',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        metaGroup: {
                            hasMedia: 'p-reset pl-3 pr-3',
                            noMedia: 'p-reset pl-2 pr-2',
                        },
                        userGroup: {
                            noMedia: 'p-reset pt-2 pl-2 pr-2 pb-0',
                            hasMedia: 'p-reset pt-2 pr-3 pl-3 pb-2',
                        },
                        postText: {
                            noMedia: 'ta-l',
                            hasMedia: 'no-grow p-reset pl-3 pr-3 pt-2 pb-2',
                        },
                        lineClampVerticalAlign: {
                            noMedia: 'middle',
                            hasMedia: 'bottom',
                        },
                        reviewRating: {
                            default: 'p-0 p-reset pr-2 pl-2 mt-4',
                        },
                        reviewTitle: {
                            default: 'f-ng-reset',
                        },
                        reviewDomain: {
                            default: 'flex left no-grow',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    showImageStyles: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    postImageTextSize: 35,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    showReplyLabels: true,
                    showReplyLabelsSize: 20,
                    showReplyBorder: true,
                    replyBorderColor: 'rgba(255,255,255,0.5)',
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 6,
                    imageTextColor: '',
                    imageBackgroundSize: 'cover',
                    imagePostHideText: false,
                    imageFaceDetection: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 30,
                    engagementMetricsPosition: 'top_right',
                    showTextStyles: true,
                    textOnlyColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    showUserGroup: true,
                    postLineClamp: true,
                    postLineClampValue: 4,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 15,
                    postTextOnlySize: 40,
                    userGroupAvatarSize: 27,
                    userGroupNameSize: 22,
                    userGroupScreenNameSize: 13,
                    userGroupPosition: 'top',
                    userGroupLayoutType: 'a',
                    showIconInUserGroup: true,
                    socialIconBgColor: false,
                    socialIconPosition: {
                        x: 'left',
                        y: 'top',
                    },
                    showText: true,
                    showTimeStamp: false,
                    timeStampSize: 13,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textFitMin: 20,
                    activePostsInWindow: 1,
                    stripLinks: true,
                    postLayoutOrientation: 'horizontal',
                    postCompositionType: 'a',
                    blastDelimiter: 'words',
                    metaThemePalette: [],
                    showSecondaryImageOverlay: false,
                    showZeroEngagementValues: false,
                    metaOffsetTotal: 8,
                    themeOffsetTotal: 2,
                    imageFiltersOpen: true,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 35,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 3,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 35,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 15,
                        },
                        message: {
                            enabled: true,
                            size: 20,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 20,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    postLayoutType: 'd',
                    textOnlyBackgroundColor: '',
                    imagePostBackgroundColor: '',
                    secondaryOverlayColor: '',
                    maxCharacters: 400,
                    comments: {
                        enabled: false,
                        background: {
                            color: 'rgba(0, 0, 0, .3)',
                        },
                        animation: {
                            enabled: true,
                            duration: 5,
                        },
                        comment: {
                            background: {
                                color: null,
                                brandEnabled: false,
                            },
                            text: {
                                color: null,
                                size: 35,
                                scale: {
                                    enabled: true,
                                    value: 50,
                                },
                                format: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 4,
                                },
                                teleprompter: {
                                    speed: 50,
                                },
                            },
                            userGroup: {
                                timeStamp: {
                                    enabled: false,
                                    size: 13,
                                    format: 'timeAgo',
                                    endianTime: 'D MMM YYYY, h:mm a',
                                },
                            },
                        },
                    },
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 40,
                            postImageTextSize: 35,
                            userGroupIconSize: 15,
                            userGroupNameSize: 22,
                            userGroupScreenNameSize: 13,
                            userGroupAvatarSize: 27,
                            engagementMetricsSize: 30,
                        },
                        optionDefaults: {
                            showUserGroup: true,
                            showEngagementMetrics: true,
                            imagePostHideText: false,
                            classOverrides: {
                                metaGroup: {
                                    hasMedia: 'p-reset pl-3 pr-3',
                                    noMedia: 'p-reset pl-2 pr-2',
                                },
                                userGroup: {
                                    noMedia: 'p-reset pt-2 pl-2 pr-2 pb-0',
                                    hasMedia: 'p-reset pt-2 pr-3 pl-3 pb-2',
                                },
                                postText: {
                                    noMedia: 'ta-l',
                                    hasMedia: 'no-grow p-reset pl-3 pr-3 pt-2 pb-2',
                                },
                                lineClampVerticalAlign: {
                                    noMedia: 'middle',
                                    hasMedia: 'bottom',
                                },
                                reviewRating: {
                                    default: 'p-0 p-reset pr-2 pl-2 mt-4',
                                },
                                reviewTitle: {
                                    default: 'f-ng-reset',
                                },
                                reviewDomain: {
                                    default: 'flex left no-grow',
                                },
                            },
                        },
                        breakpoints: {
                            m: {
                                options: {
                                    classOverrides: {
                                        metaGroup: {
                                            hasMedia: 'p-reset pl-2 pr-2',
                                            noMedia: 'p-reset pl-1 pr-1',
                                        },
                                        userGroup: {
                                            noMedia: 'p-reset pt-1 pl-1 pr-1 pb-0',
                                            hasMedia: 'p-reset pt-1 pr-2 pl-2 pb-1',
                                        },
                                        postText: {
                                            noMedia: 'ta-l',
                                            hasMedia: 'no-grow p-reset pl-2 pr-2 pt-1 pb-1',
                                        },
                                        lineClampVerticalAlign: {
                                            noMedia: 'middle',
                                            hasMedia: 'bottom',
                                        },
                                        reviewRating: {
                                            default: 'p-0 p-reset pr-1 pl-1 mt-3',
                                        },
                                        reviewTitle: {
                                            default: 'f-ng-reset',
                                        },
                                        reviewDomain: {
                                            default: 'flex left no-grow',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    classOverrides: {
                                        metaGroup: {
                                            hasMedia: 'p-reset pl-1 pr-1',
                                            noMedia: 'p-reset pl-05 pr-05',
                                        },
                                        userGroup: {
                                            noMedia: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                            hasMedia: 'p-reset pt-05 pr-1 pl-1 pb-05',
                                        },
                                        postText: {
                                            noMedia: 'ta-l',
                                            hasMedia: 'no-grow p-reset pl-1 pr-1 pt-05 pb-05',
                                        },
                                        lineClampVerticalAlign: {
                                            noMedia: 'middle',
                                            hasMedia: 'bottom',
                                        },
                                        reviewRating: {
                                            default: 'p-0 p-reset pr-05 pl-05 mt-2',
                                        },
                                        reviewTitle: {
                                            default: 'f-ng-reset',
                                        },
                                        reviewDomain: {
                                            default: 'flex left no-grow',
                                        },
                                    },
                                },
                            },
                            xs: {
                                options: {
                                    classOverrides: {
                                        metaGroup: {
                                            hasMedia: 'p-reset pl-05 pr-05',
                                            noMedia: 'p-reset pl-05 pr-05',
                                        },
                                        userGroup: {
                                            noMedia: 'p-reset pt-05 pl-05 pr-05 pb-0',
                                            hasMedia: 'p-reset pt-05 pr-05 pl-05 pb-05',
                                        },
                                        postText: {
                                            noMedia: 'ta-l',
                                            hasMedia: 'no-grow p-reset pl-05 pr-05 pt-05 pb-05',
                                        },
                                        lineClampVerticalAlign: {
                                            noMedia: 'middle',
                                            hasMedia: 'bottom',
                                        },
                                        reviewRating: {
                                            default: 'p-0 p-reset pr-05 pl-05 mt-1',
                                        },
                                        reviewTitle: {
                                            default: 'f-ng-reset',
                                        },
                                        reviewDomain: {
                                            default: 'flex left no-grow',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    source: 'REPORTING',
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    pageSize: 6,
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH_COUNT',
                                        },
                                    ],
                                    includeComments: true,
                                    showInReplyToPost: false,
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1569481200000,
                                        endTime: 1569567599999,
                                    },
                                    filters: [
                                        {
                                            dimensionName: 'TOPIC_GROUP_IDS',
                                            filterType: 'IN',
                                            values: ['5a00b9e4e4b082264ab84227'],
                                        },
                                    ],
                                    projections: [],
                                    groupBys: [],
                                },
                                options: {
                                    count: 200,
                                    imagePreload: false,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176537936575258627',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569343477754,
                                        permalink:
                                            'https://twitter.com/show/status/1176537936575258627',
                                        message:
                                            "In honor of Sprinklr's 10th birthday today, I'm also celebrating the 10lbs I lost from riding my bike to work! #sprinklr10 #sprinklrlife #bikelife https://t.co/dKrY1ueh6M https://t.co/yR4b3ShAwt",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [147, 170],
                                                    url: 'https://t.co/dKrY1ueh6M',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [171, 194],
                                                    url: 'https://t.co/yR4b3ShAwt',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [111, 122],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [123, 136],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [137, 146],
                                                    hashtag: 'bikelife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png',
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Austin, Texas, United States',
                                            lat: 30.26715,
                                            lon: -97.74306,
                                            additional: {
                                                country: 'United States',
                                                state: 'Texas',
                                                code: 'US',
                                                state_code: 'TX',
                                                city: 'Austin',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[7].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 194,
                                            numRetweets: 1,
                                            reachCount: 41730,
                                            numLikes: 17,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 83,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 17,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: [],
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'window',
                            options: {
                                padding: 1,
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '2.08%',
                    right: null,
                    top: '3.72%',
                    bottom: null,
                    width: '95.84%',
                    height: '92.56%',
                    portrait: {
                        left: '3%',
                        top: '2%',
                        width: '94%',
                        height: '96%',
                    },
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Single Post',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_single_post',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569525919853,
};
export default singlePostSnapshot;
